import { render } from "./EvolucaoScrum.vue?vue&type=template&id=4f2a6f63&scoped=true"
import script from "./EvolucaoScrum.vue?vue&type=script&lang=js"
export * from "./EvolucaoScrum.vue?vue&type=script&lang=js"

import "./EvolucaoScrum.vue?vue&type=style&index=0&id=4f2a6f63&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2a6f63"]])

export default __exports__